export default __webpack_public_path__ + "static/media/library_blue_icon.4c306f95.svg";